import { createContext } from 'react';

interface IRowOffsetContext {
  offset: number;
  height: number;
  container: HTMLDivElement | null;
}

const initialRowState: IRowOffsetContext = { offset: 0, height: 0, container: null };

export const RowOffsetContext = createContext<IRowOffsetContext>({
  ...initialRowState,
});
